import React from "react";
import { FileText } from "lucide-react";
import PaintEdges from "../components/PaintEdges";
import { LEGAL_DOCS } from "../legal";

const WiderrufsForm = ({ form }) => (
  <div className="mt-4 rounded-2xl border-2 border-dashed border-sky-200 bg-sky-50/40 p-6">
    <p className="font-bold text-slate-700 mb-3">An:</p>
    <div className="text-slate-700 space-y-0.5 mb-5">
      {form.to.map((line) => (
        <p key={line}>{line}</p>
      ))}
    </div>
    <div className="space-y-4">
      {form.fields.map((f) => (
        <div key={f}>
          <p className="text-slate-700">{f}</p>
          <div className="mt-1.5 h-8 border-b-2 border-dotted border-slate-300" />
        </div>
      ))}
    </div>
    <p className="mt-4 text-sm text-slate-500 italic">{form.note}</p>
  </div>
);

const LegalPage = ({ type }) => {
  const doc = LEGAL_DOCS[type];

  if (!doc) return null;

  return (
    <main className="relative overflow-hidden bg-gradient-to-b from-[#dff2fc] via-[#ecf9ee] to-[#fff6ea] min-h-[calc(100vh-76px)]">
      <PaintEdges from="#1b9ad6" via="#7cc24a" to="#f7941e" opacity={0.6} />

      <div className="relative mx-auto max-w-[900px] px-4 sm:px-8 py-14 lg:py-16">
        <div className="flex items-center gap-4">
          <div className="h-16 w-16 rounded-full bg-gradient-to-br from-[#1b9ad6] via-[#7cc24a] to-[#f7941e] flex items-center justify-center shadow-lg shrink-0">
            <FileText className="h-8 w-8 text-white" />
          </div>
          <div>
            <h1 className="font-display text-3xl sm:text-4xl font-extrabold">
              <span className="text-[#1b7fc1]">{doc.title.slice(0, Math.ceil(doc.title.length / 2))}</span>
              <span className="text-[#6fbf3f]">{doc.title.slice(Math.ceil(doc.title.length / 2))}</span>
            </h1>
            <p className="text-slate-500 mt-1">{doc.subtitle}</p>
          </div>
        </div>

        <div className="mt-8 card-soft p-6 sm:p-10 space-y-8">
          {doc.blocks.map((block, bi) => (
            <section key={`sec-${bi}-${block.h.slice(0, 30)}`}>
              <h2 className="font-display text-xl font-extrabold text-slate-800 mb-3">{block.h}</h2>
              <div className="space-y-3 text-slate-600 leading-relaxed text-[15px]">
                {block.p.map((para, pi) => (
                  <p key={`p-${bi}-${pi}`}>{para}</p>
                ))}
                {block.list && (
                  <ul className="list-disc list-inside space-y-1.5 pl-1">
                    {block.list.map((item, li) => (
                      <li key={`li-${bi}-${li}`}>{item}</li>
                    ))}
                  </ul>
                )}
                {block.after?.map((para, ai) => (
                  <p key={`after-${bi}-${ai}`}>{para}</p>
                ))}
              </div>
              {block.form && <WiderrufsForm form={block.form} />}
            </section>
          ))}
        </div>

        {doc.stand && (
          <p className="text-center text-sm text-slate-400 mt-8">Stand: {doc.stand}</p>
        )}
      </div>
    </main>
  );
};

export default LegalPage;
